module.exports = __webpack_public_path__ + "static/workplace-lessons-from-the-pandemic-fe3ccc138eb46cc9274847e2a50b2fa7.jpg";